module.exports = __webpack_public_path__ + "img/entertainment-6.dd2eb85a.jpg";